module.exports = __webpack_public_path__ + "static/img/cont52 (1).248c9fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont52 (1).jpg
// module id = XHvY
// module chunks = 0